<template>
  <div
    class="favorite-item"
    @click.stop="toggleFavorite"
    :class="{'cw-favorite-active' : checked}"
  >
    <span>
      {{ favorite.favoritable.name }}
      <span v-if="details" class="small ml-2">({{details}})</span>
    </span>
    <favorite-star-toggle
        :favorite="favoriteData"
        :type="favorite.favoritable_type"
    />
  </div>
</template>

<script>
import FavoriteStarToggle from '@/components/favorites/FavoriteStarToggle';
import {FAVORITE_TYPES} from '@/const';
import {mapState} from 'vuex';

export default {
  name: 'FavoriteListItem',
  components: {
    FavoriteStarToggle,
  },
  props: {
    favorite: {
      type: Object,
      required: true,
      validator(fav) {
        const fields = ['name', 'favoritable_type', 'favoritable_id'];
        return fields.every((name) => fav.hasOwnProperty(name));
      },
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      processing: false,
      checked: this.selected,
    };
  },
  watch: {
    selected() {
      this.checked = this.selected;
    },
    checked() {
      this.$emit('selected', {
        ...this.favorite,
        selected: this.checked,
      });
    },
  },
  methods: {
    toggleFavorite() {
      this.checked = !this.checked;
    },
  },
  computed: {
    ...mapState({
      participants: (state) => state.participant.participantsById,
    }),
    favoriteData() {
      return {
        id: this.favorite.favoritable_id,
        name: this.favorite.favoritable?.name,
        ...this.favorite.favoritable,
      };
    },
    details() {
      const details = [];

      if (this.favorite.favoritable_type === FAVORITE_TYPES.participant) {
        const pId = this.favoriteData.id;
        const props = this.participants[pId]?.properties;
        props?.sport?.[0] && details.push(props?.sport?.[0]);
        props?.gender?.[0] && details.push(props?.gender?.[0]);
      }
      return details.join(', ');
    },
  },
  beforeDestroy() {
    this.checked && this.$emit('selected', {
      ...this.favorite,
      selected: false,
    });
  },
};
</script>

<style scoped lang="scss">
.favorite-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .3rem 1rem;
  border-radius: .3rem;
  cursor: pointer;
  text-align: left;
}
.delete {
  padding: .5rem;
  width: 1.25rem;
  height: 1.25rem;
  box-sizing: content-box;

  &:disabled {
    background: transparent;
    filter: var(--disable-filter);
  }
}
.cw-favorite-active{
  background: var(--settings-body-text-color);
  color: var(--settings-body-background);
}
</style>
